var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "padTSM moOnly pf23-lineBtm" },
    [
      _vm.sqCode == "Q119"
        ? [
            _vm._m(0),
            _vm._v(" "),
            _c("p", { staticClass: "fntP padTSM" }, [
              _vm._v(
                "‘안전확인동의서’ 에 ‘해당사항 있음’으로 체크한 항목이 있습니까? (임산부, 장애, 지병 및 기타 질병)"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pf23-inFo-safe-L marTSM" }, [
              _c(
                "div",
                { staticClass: "amway-theme", staticStyle: { width: "55%" } },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "amw-radio-wrap radio-label focus",
                          attrs: { id: "Q119-" + _vm.seq + "-FO" }
                        },
                        [
                          _c("input", {
                            staticClass: "amw-global-radio",
                            attrs: {
                              type: "radio",
                              name: "radio01-4",
                              value: "Y",
                              disabled: _vm.disabled
                            },
                            domProps: {
                              checked:
                                _vm.participant.questions["Q119"].raw_data ===
                                "Y"
                            },
                            on: {
                              change: function($event) {
                                return _vm.inputRadioAnswer(
                                  "" + _vm.seq,
                                  "Q119",
                                  "Y"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-radio-overlay" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-label-radio-text" }, [
                            _vm._v("예")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "amw-radio-wrap radio-label focus",
                          staticStyle: { "margin-right": "1.5em" }
                        },
                        [
                          _c("input", {
                            staticClass: "amw-global-radio",
                            attrs: {
                              type: "radio",
                              name: "radio01-4",
                              value: "N",
                              disabled: _vm.disabled
                            },
                            domProps: {
                              checked:
                                _vm.participant.questions["Q119"].raw_data ===
                                "N"
                            },
                            on: {
                              change: function($event) {
                                return _vm.inputRadioAnswer(
                                  "" + _vm.seq,
                                  "Q119",
                                  "N"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-radio-overlay" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-label-radio-text" }, [
                            _vm._v("아니오")
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "marTS fntE",
                staticStyle: {
                  color: "#d91734",
                  "text-indent": "-0.6em",
                  "padding-left": "0.6em"
                }
              },
              [
                _vm._v(
                  "* 해당 사항이 있는 경우 반드시 상세 내용을 동의서 상에\n      작성하여 주시기 바랍니다."
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.sqCode == "Q120"
        ? [
            _c("p", { staticClass: "fntP" }, [_vm._v("알러지 및 식단 확인")]),
            _vm._v(" "),
            _c("p", { staticClass: "fntP padTSM" }, [
              _vm._v(
                "알러지 또는 유의해야할 식단이 있습니까? 있다면 어떤 것인지 적어주십시오."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pf23-ipE marTSM" }, [
              _c(
                "label",
                {
                  staticClass: "fntP",
                  staticStyle: { display: "none" },
                  attrs: { for: "pf23answer01" }
                },
                [_vm._v("알러지 및 식단 답변")]
              ),
              _vm._v(" "),
              _c("input", {
                staticClass: "widM ip-Max",
                attrs: {
                  type: "text",
                  id: "pf23answer01",
                  name: "pf23answer01",
                  maxlength: "30",
                  disabled: _vm.disabled
                },
                domProps: {
                  value: _vm.participant.questions[_vm.sqCode].raw_data
                },
                on: {
                  input: function($event) {
                    return _vm.inputAnyAnswer(
                      _vm.seq,
                      _vm.sqCode,
                      $event.target
                    )
                  }
                }
              })
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.sqCode == "Q121"
        ? [
            _vm._m(1),
            _vm._v(" "),
            _c("p", { staticClass: "fntP padTSM" }, [
              _vm._v("ETA(전자여행허가)를 신청하셨습니까?")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {},
              [
                _c("div", { staticClass: "pf23-ipE" }, [
                  _c(
                    "label",
                    {
                      staticClass: "fntP",
                      staticStyle: { display: "none" },
                      attrs: { for: "Q121-" + _vm.seq + "-FO" }
                    },
                    [_vm._v("답변")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "pf23-inFo-safe" }, [
                    _c(
                      "div",
                      {
                        staticClass: "amway-theme",
                        staticStyle: { width: "55%" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "amw-radio-wrap radio-label focus"
                              },
                              [
                                _c("input", {
                                  staticClass: "amw-global-radio",
                                  attrs: {
                                    type: "radio",
                                    id: "Q121-" + _vm.seq + "-FO",
                                    name: "visa-eta-radio-04",
                                    value: "Y",
                                    disabled: _vm.disabled
                                  },
                                  domProps: {
                                    checked:
                                      _vm.participant.questions[_vm.sqCode]
                                        .raw_data === "Y"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.inputVisaEtaAnswer(
                                        "" + _vm.seq,
                                        _vm.sqCode,
                                        "Y"
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "amw-radio-overlay"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "amw-label-radio-text" },
                                  [_vm._v("예")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "amw-radio-wrap radio-label focus"
                              },
                              [
                                _c("input", {
                                  staticClass: "amw-global-radio",
                                  attrs: {
                                    type: "radio",
                                    name: "visa-eta-radio-04",
                                    value: "N",
                                    disabled: _vm.disabled
                                  },
                                  domProps: {
                                    checked:
                                      _vm.participant.questions[_vm.sqCode]
                                        .raw_data === "N"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.inputVisaEtaAnswer(
                                        "" + _vm.seq,
                                        _vm.sqCode,
                                        "N"
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "amw-radio-overlay"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "amw-label-radio-text" },
                                  [_vm._v("아니오")]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.participant.questions[_vm.sqCode].raw_data == "Y"
                  ? [
                      _vm.participant.questions[_vm.sqCode].raw_data == "Y"
                        ? _c("div", { staticClass: "pf23-visa-wrap inFo-L" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pf23-inFo-L padBSM padTSM pf23-inFo-common"
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "fntP",
                                    attrs: { for: "Q122-" + _vm.seq + "-O" }
                                  },
                                  [
                                    _vm._v("비자 번호"),
                                    _c("span", {
                                      staticClass: "ico-must-astar"
                                    }),
                                    _c("br"),
                                    _vm._v("(Visa Grant Number)\n            ")
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  class:
                                    _vm.isRequired &&
                                    _vm.participant.questions["Q122"]
                                      .hasError &&
                                      _vm.participant.questions["Q122"].raw_data
                                      ? "check-red"
                                      : "",
                                  attrs: {
                                    type: "text",
                                    maxlength: "13",
                                    id: "Q122-" + _vm.seq + "-O",
                                    name: "pf23visNum01-" + _vm.seq,
                                    disabled: _vm.disabled
                                  },
                                  domProps: {
                                    value:
                                      _vm.participant.questions["Q122"].raw_data
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.inputVisaNumberAnswer(
                                        _vm.seq,
                                        "Q122",
                                        $event.target
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isRequired &&
                            _vm.participant.questions["Q122"].hasError &&
                              _vm.participant.questions["Q122"].raw_data
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "marTS fntE padBSM",
                                    staticStyle: {
                                      color: "#d91734",
                                      "text-indent": "-0.6em",
                                      "padding-left": "0.6em"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "🚫  Visa 번호 13자리를 모두 입력해주세요."
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.participant.questions[_vm.sqCode].raw_data ==
                            "Y"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pf23-inFo-L padBSM padTSM pf23-inFo-common"
                                  },
                                  [
                                    _vm._m(2),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pf23-inFo-select pf23-date"
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "NCAcmi_num",
                                          class:
                                            _vm.hint &&
                                            _vm.participant.questions["Q123"]
                                              .hasError
                                              ? "check-red"
                                              : "",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "date",
                                            id: "Q123-" + _vm.seq + "-FO",
                                            name:
                                              "NCAcmi_visa_expired_date" +
                                              _vm.seq,
                                            size: "50",
                                            maxlength: "50",
                                            disabled: _vm.disabled,
                                            min: _vm.today
                                          },
                                          domProps: {
                                            value:
                                              _vm.participant.questions["Q123"]
                                                .raw_data
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.inputVisaEtaDateAnswer(
                                                _vm.seq,
                                                "Q123",
                                                $event.target
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "marTS fntE",
                                staticStyle: {
                                  color: "#d91734",
                                  "text-indent": "-0.6em",
                                  "padding-left": "0.6em"
                                }
                              },
                              [
                                _vm.isRequired &&
                                _vm.hint &&
                                _vm.participant.questions["Q123"].hasError
                                  ? [
                                      _vm._v(
                                        "🚫 최근 10년 이전까지만 선택 가능합니다."
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "marTS fntE padBSM",
                          staticStyle: {
                            color: "#d91734",
                            "text-indent": "-0.6em",
                            "padding-left": "0.6em"
                          }
                        },
                        [
                          _vm._v(
                            "* AustrailanETA앱의 Visa Status > Visa details에서 확인 가능합니다."
                          )
                        ]
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(3)
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _vm._v("안전 확인"),
      _c("span", { staticClass: "ico-must-astar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _vm._v("VISA 발급 여부 "),
      _c("span", { staticClass: "ico-must-astar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _vm._v("비자 유효기간 "),
      _c("span", { staticClass: "ico-must-astar" }),
      _c("br"),
      _vm._v("(Visa Expiry Date)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "marTS fntP padBSM" }, [
      _c(
        "a",
        {
          staticStyle: { color: "#0075a4", "font-weight": "500" },
          attrs: {
            href:
              "https://www.youtube.com/watch?v=wFp2yij2uUA&ab_channel=호뚜루뉴뚜루",
            target: "_blank"
          }
        },
        [_vm._v("* "), _c("u", [_vm._v("ETA 신청방법 확인하기 >")])]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ec8ebf4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ec8ebf4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/sydney/components/SurveyParticipantFloatLeftOnly.vue
// module id = null
// module chunks = 